<div class="logout-message">
	<p>Please wait while you're logged out.</p>
	<div crownx-validation-error *ngIf="HasAuthenticationError">An error occurred while logging you out; please refresh the page or try <a routerLink="/login">logging in</a>.</div>
</div>
